<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        :handleClose="handleClose"
        headerText="You don't have permission to see payment information"
        :showClose="true"
      />
      <div :class="$style.modalBody">
        <div
          v-show="!showLoadingOverlay"
          data-test-id="modalBodyMessage"
        >
          <ParagraphBody v-if="billingAdmin.email">
            Contact <strong>{{ billingAdmin.email }}</strong> to get permission to view
            and edit your organization payment information.
          </ParagraphBody>
          <ParagraphBody v-else>
            Please reach out to your managed service provider for billing information.
          </ParagraphBody>
        </div>
        <LoadingOverlay
          :showLoadingOverlay="showLoadingOverlay"
        />
      </div>
      <ModalFooter
        cancelText=""
        :handleClose="handleClose"
        :handleMainAction="handleClose"
        mainActionText="ok"
      />
    </div>
  </div>
</template>

<script>
import { find, get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { ParagraphBody } from '@jumpcloud/ui-components';
import LoadingOverlay from 'client/components/LoadingOverlay/LoadingOverlay.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import ModalFooter from 'client/components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

import { UserRoleConsts } from 'client/util/Constants';

const { administratorWithBilling } = UserRoleConsts;

export default {
  name: 'NoBillingPermissionsModal',

  components: {
    LoadingOverlay,
    ModalFooter,
    ModalHeader,
    ParagraphBody,
  },

  data() {
    return {
      showLoadingOverlay: false,
    };
  },

  computed: {
    ...mapGetters('UserCollection', {
      users: 'getCollection',
    }),

    /**
     * Admin !== Admin with Billing
     * See https://support.jumpcloud.com/support/s/article/JumpCloud-Roles
     */
    billingAdmin() {
      const admin = find(this.users, user => get(user, 'roleName') === administratorWithBilling);

      return admin || {};
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions('AlertModule', [
      'triggerErrorAlert',
    ]),

    ...mapActions('UserCollection', [
      'fetchCollection',
      'setSortField',
    ]),

    handleClose() {
      ModalEventBus.close();
    },

    async handleMounted() {
      this.showLoadingOverlay = true;
      this.setSortField({ sortField: 'created' });

      try {
        await this.fetchCollection();
      } catch {
        this.triggerErrorAlert('Unable to fetch collection');
      } finally {
        this.showLoadingOverlay = false;
      }
    },
  },
};
</script>

<style module>
@import '../Modal/css/ModalStyles.css';
</style>
